import Image from 'next/image';
import {
    WhyAckoWrapper,
    Title,
    OptionsWrapper,
    Option,
    OptionHeading,
    OptionSubHeading,
} from './styles';
import { getImageBasePath } from '@utils/generics';

interface IProps {
    isMobile: boolean;
}

interface OptionsIProps {
    image: string;
    heading: string;
    subHeading: string;
    isMobile: boolean;
}

const options = [
    {
        image: '/images/launch.svg',
        heading: 'Effortless Launch',
        subHeading:
            'Launch insurance in a day with our quick and easy-to-integrate RESTful APIs.',
    },
    {
        image: '/images/plan.svg',
        heading: 'Tailor-made Plans',
        subHeading:
            'Get insurance solutions that are customised to meet your business needs.',
    },
    {
        image: '/images/experience.svg',
        heading: 'Great Customer Experience',
        subHeading:
            'Upgrade customer experience with quick claim settlement & easy paperless process.',
    },
];

const WhyAckoOption = (props: OptionsIProps) => {
    const { image, heading, subHeading, isMobile } = props;

    return (
        <Option>
            <Image
                src={getImageBasePath(image)}
                height={isMobile ? '86px' : '115px'}
                width={isMobile ? '86px' : '115px'}
            />
            <OptionHeading>{heading}</OptionHeading>
            <OptionSubHeading>{subHeading}</OptionSubHeading>
        </Option>
    );
};

const WhyAcko = ({ isMobile }: IProps) => {
    return (
        <WhyAckoWrapper>
            <Title>Why Acko</Title>
            <OptionsWrapper>
                {options?.map((option, i) => {
                    const { image, heading, subHeading } = option;

                    return (
                        <WhyAckoOption
                            key={i}
                            image={image}
                            heading={heading}
                            subHeading={subHeading}
                            isMobile={isMobile}
                        />
                    );
                })}
            </OptionsWrapper>
        </WhyAckoWrapper>
    );
};

export default WhyAcko;
